

<template>
  <div>
    <b-col
        md="6"
        xl="6"
        style="margin-top: 1em"
    >
    <l-map
        :zoom="zoom"
        :center="center"
    >
      <l-tile-layer :url="url" />
      <l-circle
          :lat-lng="circle.center"
          :radius="circle.radius"
          :color="circle.color"
      />
    </l-map>
    </b-col>
  </div>
</template>

<script>
import { LMap, LTileLayer, LCircle } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import BCardCode from '@core/components/b-card-code'
import {
  BTable,
  BFormCheckbox,
  BBadge,
  BFormSelect,
  BButton,
  BCol,
  BFormGroup,
  BFormInput,
  BRow,
  BDropdown,
  BDropdownDivider,
  BDropdownForm,
  BDropdownGroup,
  BDropdownItem,
  BPopover,
  BTab,
  BTabs,
  BInputGroupPrepend,
  BInputGroupAppend,
  VBTooltip, BInputGroup,
} from 'bootstrap-vue'

export default {
  components: {
    LMap,
    LTileLayer,
    LCircle,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 8,
      center: [47.313220, -1.319482],
      circle: {
        center: [47.413220, -1.0482],
        radius: 4500,
        color: '#EA5455',
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Karte'
    })
  }
}
</script>

<style lang="scss">
.vue2leaflet-map{
  &.leaflet-container{
    height: 350px;
  }
}
</style>